import React, { useEffect, useState } from "react";
import firebase from '../../config/firebase';
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import InputMask from 'react-input-mask';
import {
    Box,
    Button,
    Card,
    CardContent,
    CircularProgress,
    Divider,
    Stack,
    Typography,
} from "@mui/material";
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import { Input, Select } from "antd";
import { useSelector } from "react-redux"; // identificador do user
import { Link } from 'react-router-dom';
import NewMiniDrawer from "../../components/navMenu/menu-nav";
import { cardIconSx, newClientThemeVars } from "../../theme/globalStyle/globalStyle";
import './client.css';
import { GlobalErrorModal, GlobalSuccessModal, GlobalWarningGlobal } from "../../components/modalGlobal/modalGlobal";
import { validatorEmail, validatorCPF, validatorCNPJ } from "../../components/validators/validators";

require('firebase/auth')

const STATE_UF = [
    { value: "AC", label: "Acre (AC)" },
    { value: "AL", label: "Alagoas (AL)" },
    { value: "AP", label: "Amapá (AP)" },
    { value: "AM", label: "Amazonas (AM)" },
    { value: "BA", label: "Bahia (BA)" },
    { value: "CE", label: "Ceará (CE)" },
    { value: "DF", label: "Distrito Federal (DF)" },
    { value: "ES", label: "Espírito Santo (ES)" },
    { value: "GO", label: "Goiás (GO)" },
    { value: "MA", label: "Maranhão (MA)" },
    { value: "MT", label: "Mato Grosso (MT)" },
    { value: "MS", label: "Mato Grosso do Sul (MS)" },
    { value: "MG", label: "Minas Gerais (MG)" },
    { value: "PA", label: "Pará (PA)" },
    { value: "PB", label: "Paraíba (PB)" },
    { value: "PR", label: "Paraná (PR)" },
    { value: "PE", label: "Pernambuco (PE)" },
    { value: "PI", label: "Piauí (PI)" },
    { value: "RJ", label: "Rio de Janeiro (RJ)" },
    { value: "RN", label: "Rio Grande do Norte (RN)" },
    { value: "RS", label: "Rio Grande do Sul (RS)" },
    { value: "RO", label: "Rondônia (RO)" },
    { value: "RR", label: "Roraima (RR)" },
    { value: "SC", label: "Santa Catarina (SC)" },
    { value: "SP", label: "São Paulo (SP)" },
    { value: "SE", label: "Sergipe (SE)" },
    { value: "TO", label: "Tocantins (TO)" },
];

function NewClient() {

    const user = useSelector(state => state.user) // Criando uma constante para uso do user
    const { id } = useParams();

    const location = useLocation();

    var navigate = useNavigate();

    const [view, setOnlyView] = useState(location.state?.viewOnly || false);

    const [socialName, setSocialName] = useState("");
    const [socialNameError, setSocialNameError] = useState("");

    const [nameFantasy, setNameFantasy] = useState("");
    const [nameFantasyError, setNameFantasyError] = useState("");

    const [cnpj, setCnpj] = useState("");
    const [cnpjError, setCnpjError] = useState("");
    const [cpfError, setCpfError] = useState("");
    const [emailError, setEmailError] = useState("");

    const [typePerson, setTypePerson] = useState(1);


    const [cep, setCep] = useState("");
    const [cepError, setCepError] = useState("");

    const [street, setStreet] = useState("");
    const [streetError, setStreetError] = useState("");

    const [neighborhood, setNeighborhood] = useState("");//bairro
    const [neighborhoodError, setNeighborhoodError] = useState("");//bairro

    const [city, setCity] = useState("");
    const [cityError, setCityError] = useState("");

    const [state, setState] = useState("");
    const [stateError, setStateError] = useState("");

    const [number, setNumber] = useState("");

    const [longitude, setLongitude] = useState();
    const [longitudeError, setLongitudeError] = useState();

    const [latitude, setLatitude] = useState();
    const [latitudeError, setLatitudeError] = useState();

    const [cepDelivery, setCepDelivery] = useState("");
    const [cepEntregaError, setCepEntregaError] = useState("");

    const [streetDelivery, setStreetDelivery] = useState("");
    const [streetDeliveryError, setStreetDeliveryError] = useState("");

    const [neighborhoodDelivery, setNeighborhoodDelivery] = useState("");//bairro
    const [neighborhoodDeliveryError, setNeighborhoodDeliveryError] = useState("");//bairro

    const [cityDelivery, setCityDelivery] = useState("");
    const [cityDeliveryError, setCityDeliveryError] = useState("");

    const [stateDelivery, setStateDelivery] = useState("");
    const [stateDeliveryError, setStateDeliveryError] = useState("");

    const [numberDelivery, setNumberDelivery] = useState("");

    const [longitudeDelivery, setLongitudeDelivery] = useState();
    const [longitudeDeliveryError, setLongitudeDeliveryError] = useState();

    const [latitudeDelivery, setLatitudeDelivery] = useState();
    const [latitudeDeliveryError, setLatitudeDeliveryError] = useState();


    const [responsible, setResponsible] = useState("");
    const [phoneResp, setPhoneResp] = useState("");
    const [email, setEmail] = useState("");

    const [msgTipo, setMsgTipo] = useState();
    const [carregando, setCarregando] = useState(0);
    const [open, setOpen] = useState(false);
    const [msg, setMsg] = useState();
    const [title, setTitle] = useState();

    const db = firebase.firestore();

    const [showErrorModal, setShowErrorModal] = useState(false);
    const [errorModalTitle, setErrorModalTitle] = useState("");

    useEffect(() => {

        db.collection('client').doc(id)
            .get().then(async (result) => {

                var data = result.data();
                if (id) {

                    setTypePerson(data.typePerson)
                    setSocialName(data.name)
                    setNameFantasy(data.nameFantasy)
                    setCnpj(data.cnpj)

                    setCep(data.address.cep)
                    setStreet(data.address.street)
                    setNeighborhood(data.address.neighborhood)
                    setCity(data.address.city)
                    setState(data.address.state)
                    setNumber(data.address.number)
                    // setLatitude(data.address.coordinates.latitude)
                    // setLongitude(data.address.coordinates.longitude)

                    setCepDelivery(data.addressDelivery.cep)
                    setStreetDelivery(data.addressDelivery.street)
                    setNeighborhoodDelivery(data.addressDelivery.neighborhood)
                    setCityDelivery(data.addressDelivery.city)
                    setStateDelivery(data.addressDelivery.state)
                    setNumberDelivery(data.addressDelivery.number)
                    // setLatitudeDelivery(data.addressDelivery.coordinatesDelivery.latitude)
                    // setLongitudeDelivery(data.addressDelivery.coordinatesDelivery.longitude)

                    setResponsible(data.responsible.responsible)
                    setPhoneResp(data.responsible.phoneResp)
                    setEmail(data.responsible.email)
                }

            }).catch(error => {
                setCarregando(0)
                console.log(error)
            });

    }, [carregando]);

    //Função para consultar CEP
    function buscarCep(input) {
        const clean = input ? input.replace(/\D/g, "") : "";
        if (clean.length < 8) {
            setCepError("");
            return;
        } else {
            fetch('https://viacep.com.br/ws/' + clean + '/json/', { mode: 'cors' })
                .then((res) => res.json())
                .then((data) => {
                    if (data.hasOwnProperty("erro") || data.erro) {
                        setCepError("Esse CEP é inválido!");
                        setStreet("");
                        setNeighborhood("");
                        setCity("");
                        setState("");
                    } else {
                        setCepError("");
                        setStreet(data?.logradouro || "");
                        setNeighborhood(data?.bairro || "");
                        setCity(data?.localidade || "");
                        setState(data?.uf || "");
                    }
                })
                .catch(err => {
                    console.log(err);
                    setCepError("Esse CEP é inválido!");
                });
        }
    }
    function buscarCepDelivery(input) {
        const clean = input ? input.replace(/\D/g, "") : "";
        if (clean.length < 8) {
            setCepEntregaError("");
            return;
        } else {
            fetch('https://viacep.com.br/ws/' + clean + '/json/', { mode: 'cors' })
                .then((res) => res.json())
                .then((data) => {
                    if (data.hasOwnProperty("erro") || data.erro) {
                        setCepEntregaError("Esse CEP é inválido!");
                        setStreetDelivery("");
                        setNeighborhoodDelivery("");
                        setCityDelivery("");
                        setStateDelivery("");
                    } else {
                        setCepEntregaError("");
                        setStreetDelivery(data?.logradouro || "");
                        setNeighborhoodDelivery(data?.bairro || "");
                        setCityDelivery(data?.localidade || "");
                        setStateDelivery(data?.uf || "");
                    }
                })
                .catch(err => {
                    console.log(err);
                    setCepEntregaError("Esse CEP é inválido!");
                });
        }
    }

    function buscarCNPJ(input) {
        if (input.length === 14) {
            const inputLimpo = input.replace(/[^\d]/g, "");
            fetch('https://api.cnpjs.dev/v1/' + inputLimpo, { mode: 'cors' })
                .then((res) => res.json())
                .then((data) => {

                    if (data.hasOwnProperty("erro")) {
                        alert('CNPJ não existente');
                    } else if (data.status == 404) {
                        console.log(data.status);
                        return;
                    } else {
                        setSocialName(data?.razao_social)
                        setCnpj(data?.cnpj)
                        setNameFantasy(data?.nome_fantasia ? data?.nome_fantasia : data?.razao_social)
                        setPhoneResp(data?.telefone1)
                        setCep(data?.endereco.cep)
                        setStreet(data?.endereco.logradouro + ' - ' + data?.endereco.complemento)
                        setNumber(data?.endereco.numero)
                        setNeighborhood(data?.endereco.bairro)
                        setCity(data?.endereco.municipio)
                        setState(data?.endereco.uf)
                    }
                })
                .catch(err => {
                    console.log("Error ")
                    console.log(err)

                });
        } else if (input.length === 18) {
            const inputLimpo = input.replace(/[^\d]/g, "");
            fetch('https://api.cnpjs.dev/v1/' + inputLimpo, { mode: 'cors' })
                .then((res) => res.json())
                .then((data) => {

                    if (data.hasOwnProperty("erro")) {
                        alert('CNPJ não existente');
                    } else if (data.status == 404) {
                        console.log(data.status);
                        return;
                    } else {
                        console.log(data);
                        setSocialName(data?.razao_social)
                        setCnpj(data?.cnpj)
                        setNameFantasy(data?.nome_fantasia ? data?.nome_fantasia : data?.razao_social)
                        setPhoneResp(data?.telefone1)
                        setCep(data?.endereco?.cep)
                        setStreet(data?.endereco?.logradouro + ' - ' + data?.endereco?.complemento)
                        setNumber(data?.endereco?.numero)
                        setNeighborhood(data?.endereco?.bairro)
                        setCity(data?.endereco?.municipio)
                        setState(data?.endereco?.uf)
                    }
                })
                .catch(err => console.log(err));
        } else {
            return;
        }
    }


    function save() {
        if (email && !validatorEmail(email)) {
            setErrorModalTitle("Por favor, insira um e-mail válido!");
            setShowErrorModal(true);
            setCarregando(0);
            return;
        }
        setCarregando(1)

        var address = {
            cep: cep,
            street: street,
            neighborhood: neighborhood,
            number: number,
            city: city,
            state: state
            // coordinates: coordinates
        }

        var addressDelivery = {
            cep: cepDelivery,
            street: streetDelivery,
            neighborhood: neighborhoodDelivery,
            number: numberDelivery,
            city: cityDelivery,
            state: stateDelivery
        }

        var responsibleData = {
            responsible: responsible,
            phoneResp: phoneResp,
            email: email
        }


        var data = {
            name: socialName,
            nameFantasy: nameFantasy,
            typePerson: typePerson,
            cnpj: typePerson === 2 ? cnpj : '',
            cpf: typePerson === 1 ? cnpj : '',
            address: address,
            addressDelivery: addressDelivery,
            responsible: responsibleData,
            uidShipper: user.uidShipper,
        }

        console.log(data)

        db.collection("client").add(data).then(() => {
            setCarregando(0);
            setMsgTipo('sucesso');
            setTitle('Cliente cadastrado com sucesso!');
            setOpen(true);
        }).catch(error => {
            setMsgTipo('erro')
            setCarregando(0)
            setTitle(' Ops!')
            setMsg('Houve um problema interno ao cadastrar os dados do Cliente');
            setOpen(true)
        });
    }

    const handleClose = () => {
        setOpen(false);
        if (msgTipo === 'sucesso') {
            navigate("/clientList");
        }
    };

    function update() {
        if (email && !validatorEmail(email)) {
            setErrorModalTitle("Por favor, insira um e-mail válido!");
            setShowErrorModal(true);
            setCarregando(0);
            return;
        }
        setCarregando(1)

        var address = {
            cep: cep,
            street: street,
            neighborhood: neighborhood,
            city: city,
            state: state,
            number: number,
        }

        var addressDelivery = {
            cep: cepDelivery,
            street: streetDelivery,
            neighborhood: neighborhoodDelivery,
            number: numberDelivery,
            city: cityDelivery,
            state: stateDelivery
        }

        var responsibleData = {
            responsible: responsible,
            phoneResp: phoneResp,
            email: email
        }

        var data = {
            name: socialName,
            nameFantasy: nameFantasy,
            typePerson: typePerson,
            cnpj: typePerson === 2 ? cnpj : "",
            cpf: typePerson === 1 ? cnpj : "",
            address: address,
            addressDelivery: addressDelivery,
            responsible: responsibleData,

        }

        db.collection("client").doc(id).update(data).then(() => {
            setCarregando(0);
            setMsgTipo('sucesso');
            setTitle('Cliente atualizado com sucesso!');
            setOpen(true);
        }).catch(error => {
            setMsgTipo('erro');
            setCarregando(0);
            setTitle('Houve um problema interno ao atualizar o Cliente.');
            setOpen(true);
        });
    }

    const showChangeType = (value) => {
        if (value === 2) {
            return (
                <>
                    <InputMask
                        disabled={view}
                        fullWidth
                        className="form-control"
                        focused={cnpj && cnpj}
                        mask="99.999.999/9999-99"
                        onChange={(e) => {
                            buscarCNPJ(e.target.value);
                            setCnpj(e.target.value);
                        }}
                        value={cnpj && cnpj}
                        placeholder="CNPJ"
                        required={cnpj && cnpj}
                    />
                </>
            )
        } else {
            return (
                <>
                    <InputMask
                        disabled={view}
                        mask="999.999.999-99"
                        fullWidth
                        maskChar={""}
                        className="form-control"
                        focused={cnpj && cnpj}
                        onChange={(e) => {
                            setCnpj(e.target.value);
                            const clean = e.target.value.replace(/\D/g, "");
                            if (clean.length === 11) {
                                if (!validatorCPF(clean)) {
                                    setCpfError("Esse CPF é inválido!");
                                } else {
                                    setCpfError("");
                                }
                            } else {
                                setCpfError("");
                            }
                        }}
                        onBlur={(e) => {
                            const clean = e.target.value.replace(/\D/g, "");
                            if (clean && !validatorCPF(clean)) {
                                setCpfError("Esse CPF é inválido!");
                            } else {
                                setCpfError("");
                            }
                        }}
                        value={cnpj && cnpj}
                        placeholder="CPF"
                    />
                    {cpfError && (
                        <small style={{ color: "#ff4d4f", fontSize: "12px", marginTop: "4px", display: "block" }}>
                            {cpfError}
                        </small>
                    )}
                </>
            )
        }
    }

    const pageTitle = view ? "Visualizacao de cliente" : id ? "Editar cliente" : "Cadastro de cliente";
    const pageSubtitle = view
        ? "Consulte os dados cadastrais, fiscais e de contato do cliente."
        : "Organize os dados cadastrais, enderecos e contato principal do cliente em um unico fluxo.";

    return (
        <>
            <NewMiniDrawer divOpen={
                <Box className="new-client-page" sx={pageWrapperSx} style={newClientThemeVars}>
                    <Card sx={heroCardSx}>
                        <CardContent sx={{ p: { xs: 2, md: 3 } }}>
                            <Box className="new-client-hero">
                                <Stack spacing={1}>
                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                        <Box sx={cardIconSx}>
                                            <PersonOutlineOutlinedIcon sx={{ color: "#ffffff" }} />
                                        </Box>
                                        <Typography sx={heroTitleSx}>{pageTitle}</Typography>
                                    </Box>
                                    <Typography sx={heroSubtitleSx}>{pageSubtitle}</Typography>
                                </Stack>

                                {view ? (
                                    <Box sx={statusPillSx}>Somente leitura</Box>
                                ) : (
                                    <Box sx={statusPillSx}>{id ? "Atualizacao" : "Novo registro"}</Box>
                                )}
                            </Box>
                        </CardContent>
                    </Card>

                    <Box className="new-client-form">
                        <SectionCard
                            icon={<BadgeOutlinedIcon sx={{ color: "#ffffff" }} />}
                            title="Dados cadastrais"
                            subtitle="Identificacao fiscal e nome comercial usados nas operacoes."
                        >
                            <Box className="new-client-grid">
                                <Field label="Tipo de cliente" span={2}>
                                    <Select
                                        disabled={view}
                                        defaultValue="Tipo de cliente"
                                        onChange={(e) => { setTypePerson(e) }}
                                        value={typePerson && typePerson}
                                        options={[
                                            {
                                                value: 1,
                                                label: 'Pessoa Fisica',
                                            },
                                            {
                                                value: 2,
                                                label: 'Pessoa Juridica',
                                            },
                                        ]}
                                    />
                                </Field>

                                <Field label={typePerson === 2 ? 'CNPJ' : 'CPF'} span={3}>
                                    {showChangeType(typePerson)}
                                </Field>

                                <Field label="Razao Social" span={3}>
                                    <Input
                                        disabled={view}
                                        placeholder="Razao Social"
                                        onChange={(e) => setSocialName(e.target.value)}
                                        value={socialName && socialName}
                                        id="socialName"
                                    />
                                </Field>

                                <Field label="Nome Fantasia" span={4}>
                                    <Input
                                        disabled={view}
                                        placeholder="Nome fantasia"
                                        onChange={(e) => setNameFantasy(e.target.value)}
                                        value={nameFantasy && nameFantasy}
                                        id="nameFantasy"
                                    />
                                </Field>
                            </Box>
                        </SectionCard>

                        <SectionCard
                            icon={<LocationOnOutlinedIcon sx={{ color: "#ffffff" }} />}
                            title="Endereco fiscal"
                            subtitle="Endereco principal para cadastro, documentos e consulta por CEP."
                        >
                            <Box className="new-client-grid">
                                <Field label="CEP" span={2}>
                                    <InputMask
                                        disabled={view}
                                        mask="99999-999"
                                        className="form-control"
                                        placeholder="CEP"
                                        onChange={(e) => {
                                            buscarCep(e.target.value);
                                            setCep(e.target.value);
                                        }}
                                        value={cep && cep}
                                        id="cep"
                                    />
                                    {cepError && (
                                        <small style={{ color: "#ff4d4f", fontSize: "12px", marginTop: "4px", display: "block" }}>
                                            {cepError}
                                        </small>
                                    )}
                                </Field>

                                <Field label="Endereco" span={4}>
                                    <Input
                                        disabled={view}
                                        type="text"
                                        onChange={(e) => setStreet(e.target.value)}
                                        value={street && street}
                                        placeholder="Endereco"
                                    />
                                </Field>

                                <Field label="Numero" span={1}>
                                    <Input
                                        disabled={view}
                                        onChange={(e) => setNumber(e.target.value.replace(/\D/g, ""))}
                                        value={number && number}
                                        placeholder="Numero"
                                    />
                                </Field>

                                <Field label="Bairro" span={2}>
                                    <Input
                                        disabled={view}
                                        onChange={(e) => setNeighborhood(e.target.value)}
                                        value={neighborhood && neighborhood}
                                        placeholder="Bairro"
                                    />
                                </Field>

                                <Field label="Cidade" span={2}>
                                    <Input
                                        disabled={view}
                                        onChange={(e) => setCity(e.target.value)}
                                        value={city && city}
                                        placeholder="Cidade"
                                    />
                                </Field>

                                <Field label="UF" span={1}>
                                    <Select
                                        disabled={view}
                                        style={{ width: "100%" }}
                                        placeholder="Selecione"
                                        onChange={(value) => setState(value)}
                                        value={state || undefined}
                                        options={STATE_UF}
                                        showSearch
                                        optionFilterProp="label"
                                    />
                                </Field>

                            </Box>
                        </SectionCard>
                        <SectionCard
                            icon={<LocalShippingOutlinedIcon sx={{ color: "#ffffff" }} />}
                            title="Endereco de entrega"
                            subtitle="Local operacional usado como destino padrao nas entregas."
                        >
                            <Box className="new-client-grid">
                                <Field label="CEP" span={2}>
                                    <InputMask
                                        disabled={view}
                                        mask="99999-999"
                                        className="form-control"
                                        onChange={(e) => {
                                            buscarCepDelivery(e.target.value);
                                            setCepDelivery(e.target.value);
                                        }}
                                        value={cepDelivery && cepDelivery}
                                        placeholder="CEP"
                                    />
                                    {cepEntregaError && (
                                        <small style={{ color: "#ff4d4f", fontSize: "12px", marginTop: "4px", display: "block" }}>
                                            {cepEntregaError}
                                        </small>
                                    )}
                                </Field>

                                <Field label="Endereco" span={4}>
                                    <Input
                                        disabled={view}
                                        type="text"
                                        onChange={(e) => setStreetDelivery(e.target.value)}
                                        value={streetDelivery && streetDelivery}
                                        placeholder="Endereco"
                                    />
                                </Field>

                                <Field label="Numero" span={1}>
                                    <Input
                                        disabled={view}
                                        onChange={(e) => setNumberDelivery(e.target.value.replace(/\D/g, ""))}
                                        value={numberDelivery && numberDelivery}
                                        placeholder="Numero"
                                    />
                                </Field>

                                <Field label="Bairro" span={2}>
                                    <Input
                                        disabled={view}
                                        onChange={(e) => setNeighborhoodDelivery(e.target.value)}
                                        value={neighborhoodDelivery && neighborhoodDelivery}
                                        placeholder="Bairro"
                                    />
                                </Field>

                                <Field label="Cidade" span={2}>
                                    <Input
                                        disabled={view}
                                        onChange={(e) => setCityDelivery(e.target.value)}
                                        value={cityDelivery && cityDelivery}
                                        placeholder="Cidade"
                                    />
                                </Field>

                                <Field label="UF" span={1}>
                                    <Select
                                        disabled={view}
                                        style={{ width: "100%" }}
                                        placeholder="Selecione"
                                        onChange={(value) => setStateDelivery(value)}
                                        value={stateDelivery || undefined}
                                        options={STATE_UF}
                                        showSearch
                                        optionFilterProp="label"
                                    />
                                </Field>
                            </Box>
                        </SectionCard>

                        <SectionCard
                            icon={<BusinessOutlinedIcon sx={{ color: "#ffffff" }} />}
                            title="Contato"
                            subtitle="Responsavel principal para tratativas comerciais e operacionais."
                        >
                            <Box className="new-client-grid">
                                <Field label="Responsavel" span={4}>
                                    <Input
                                        disabled={view}
                                        onChange={(e) => setResponsible(e.target.value)}
                                        value={responsible && responsible}
                                        placeholder="Contato"
                                    />
                                </Field>

                                <Field label="Telefone" span={4}>
                                    <InputMask
                                        disabled={view}
                                        mask="(99) 99999-9999"
                                        className="form-control"
                                        onChange={(e) => setPhoneResp(e.target.value)}
                                        value={phoneResp && phoneResp}
                                        placeholder="(99) 99999-9999"
                                    />
                                </Field>

                                <Field label="E-mail" span={4}>
                                    <Input
                                        disabled={view}
                                        onChange={(e) => {
                                            const val = e.target.value;
                                            setEmail(val);
                                            if (val && !validatorEmail(val)) {
                                                setEmailError("Esse e-mail é inválido!");
                                            } else {
                                                setEmailError("");
                                            }
                                        }}
                                        onBlur={(e) => {
                                            const val = e.target.value;
                                            if (val && !validatorEmail(val)) {
                                                setEmailError("Esse e-mail é inválido!");
                                            } else {
                                                setEmailError("");
                                            }
                                        }}
                                        value={email && email}
                                        placeholder="E-mail"
                                    />
                                    {emailError && (
                                        <small style={{ color: "#ff4d4f", fontSize: "12px", marginTop: "4px", display: "block" }}>
                                            {emailError}
                                        </small>
                                    )}
                                </Field>
                            </Box>
                        </SectionCard>

                        <Card sx={actionsCardSx}>
                            <CardContent sx={{ p: { xs: 2, md: 2.4 } }}>
                                <Box className="new-client-actions">
                                    <Button
                                        component={Link}
                                        to="/clientList"
                                        variant="outlined"
                                        startIcon={<ArrowBackOutlinedIcon />}
                                        sx={secondaryActionSx}
                                    >
                                        Voltar
                                    </Button>
                                    <Button
                                        disabled={view || carregando}
                                        variant="contained"
                                        startIcon={carregando ? <CircularProgress color="inherit" size={16} /> : <SaveOutlinedIcon />}
                                        onClick={id ? update : save}
                                        sx={primaryActionSx}
                                    >
                                        {carregando ? "Salvando..." : "Salvar"}
                                    </Button>
                                </Box>
                            </CardContent>
                        </Card>
                        <GlobalSuccessModal
                            open={open}
                            handleClose={handleClose}
                            title={title}
                            subtitle={msgTipo === 'erro' ? msg : undefined}
                        />
                        <GlobalWarningGlobal
                            open={showErrorModal}
                            handleClose={() => setShowErrorModal(false)}
                            title={errorModalTitle}
                        />

                    </Box>
                </Box>
            } />
        </>
    )
}

function SectionCard({ icon, title, subtitle, children }) {
    return (
        <Card sx={sectionCardSx}>
            <CardContent sx={{ p: { xs: 2, md: 2.4 } }}>
                <Box className="new-client-section-heading">
                    <Box sx={cardIconSx}>{icon}</Box>
                    <Box>
                        <Typography sx={sectionTitleSx}>{title}</Typography>
                        <Typography sx={sectionSubtitleSx}>{subtitle}</Typography>
                    </Box>
                </Box>
                <Divider sx={{ mb: 2, borderColor: "rgba(1, 36, 67, 0.10)" }} />
                {children}
            </CardContent>
        </Card>
    );
}

function Field({ label, span = 3, children }) {
    return (
        <div className={`new-client-field new-client-span-${span}`}>
            <label>{label}</label>
            {children}
        </div>
    );
}

const pageWrapperSx = {
    p: { xs: 2, md: 3 },
    display: "flex",
    flexDirection: "column",
    gap: 2,
};

const heroCardSx = {
    borderRadius: "18px",
    border: "1px solid var(--new-client-primary-border)",
    boxShadow: "var(--new-client-shadow-soft)",
};

const sectionCardSx = {
    borderRadius: "var(--new-client-radius-lg)",
    border: "1px solid var(--new-client-primary-border)",
    boxShadow: "var(--new-client-shadow-section)",
    background: "var(--new-client-surface-soft)",
};

const actionsCardSx = {
    borderRadius: "var(--new-client-radius-lg)",
    border: "1px solid var(--new-client-primary-border)",
    boxShadow: "var(--new-client-shadow-section)",
};

const heroTitleSx = {
    color: "var(--new-client-primary)",
    fontWeight: 700,
    fontSize: "1.25rem",
};

const heroSubtitleSx = {
    color: "rgba(1, 36, 67, 0.74)",
    fontSize: "0.92rem",
    lineHeight: 1.5,
    maxWidth: 760,
};

const sectionTitleSx = {
    color: "var(--new-client-primary)",
    fontWeight: 700,
    fontSize: "1.05rem",
};

const sectionSubtitleSx = {
    color: "rgba(1, 36, 67, 0.62)",
    fontSize: "0.79rem",
    lineHeight: 1.45,
};

const statusPillSx = {
    border: "1px solid var(--new-client-primary-border)",
    borderRadius: "999px",
    color: "var(--new-client-primary)",
    background: "var(--new-client-primary-soft)",
    fontSize: "0.78rem",
    fontWeight: 700,
    px: 1.4,
    py: 0.6,
    whiteSpace: "nowrap",
};

const primaryActionSx = {
    textTransform: "none",
    fontWeight: 600,
    borderRadius: "10px",
    backgroundColor: "var(--new-client-primary)",
    minHeight: 40,
    px: 2,
    whiteSpace: "nowrap",
    "&:hover": {
        backgroundColor: "var(--new-client-primary-hover)",
    },
};

const secondaryActionSx = {
    textTransform: "none",
    fontWeight: 600,
    borderRadius: "10px",
    borderColor: "rgba(1, 36, 67, 0.28)",
    color: "var(--new-client-primary)",
    minHeight: 40,
    px: 2,
};

export default NewClient;